(function(SectionNav, $, undefined) {

  var updateActiveSectionNavItem = function(currentSection) {
    $('[data-section-anchor]').removeClass('active');
    $('[data-section-anchor="' + currentSection + '"]').addClass('active');
  }

  var initSectionNav = function() {
    let currentSection

    $('[data-section]').each(function() {
      new Waypoint({
        element: $(this),
        handler: function(direction) {
          if (direction === 'down') {
            currentSection = $(this.element).attr('data-section');
            if (!Scroll.pauseWaypointFunctions) {
              updateActiveSectionNavItem(currentSection)
            }
          }
        },
        offset: Variables.sectionMenuHeight
      })

      new Waypoint({
        element: $(this),
        handler: function(direction) {
          if (direction === 'up') {
            currentSection = $(this.element).prev().attr('data-section');
            if (!Scroll.pauseWaypointFunctions) {
              updateActiveSectionNavItem(currentSection)
            }
          }
        },
        offset: Variables.headerHeight + Variables.sectionMenuHeight
      })
    })
  }

  var bindUIActions = function() {
    $(document).on('click', '[data-section-anchor]', function(e) {
      const sectionAnchor = $(this).attr('data-section-anchor');
      const $section = $('[data-section="' + sectionAnchor + '"]')
      const sectionOffset = $section.offset().top
      const isSticky = $('.sticky-nav-active').length
      let offset

      if (sectionOffset > window.scrollY) {
        offset = Variables.sectionMenuHeight
      } else {
        offset = Variables.headerHeight + Variables.sectionMenuHeight
      }

      updateActiveSectionNavItem(sectionAnchor)

      Scroll.pauseWaypointFunctions = true;
      Scroll.smoothScroll($section, offset, 300)
    });
  }

  SectionNav.init = function() {
    initSectionNav();
    bindUIActions();
  }

}(window.SectionNav = window.SectionNav || {}, jQuery));